import React,{useEffect, useState} from 'react';
import {ChakraProvider, theme, Box,  Button, NumberInput ,NumberInputField, Text, Link, Flex, Tooltip} from "@chakra-ui/react";
import  LoginTitleCard from '../components/LoginTitleCard';
import OtpCardCheckout from '../components/OtpCardCheckout';
import { getCountry, login, sendOtp } from '../apis/User';
import ReactFlagsSelect from 'react-flags-select';
import { useHistory, useLocation } from 'react-router';
import { useStoreActions, useStoreState } from 'easy-peasy';
const InstantCheckout = props =>{
  const history = useHistory()
  const [otpCardShow, SetOtpCardShow] = useState(false);
  const [userCountry, setUserCountry] = useState('+91');
  const [mobileNo, SetMobileNo] = useState();
  const [countryCodes, setCountryCodes] = useState([]);
  const [countryLables, setCountryLables] = useState([]);
  const isUserLogged = useStoreState(store => store.isUserLogged);
  const redirectBack = window.location.pathname.split('=')[1];
  const [selected, setSelected] = useState('');
  const [showToolTip, setShowToolTip] = useState(false);
  const location = useLocation();

  useEffect( () => {    
    console.log(location, 'Location');
    return (isUserLogged) ? history.goBack() : redirectBack 
  },[])

  const OtpCardBtn = () =>{
    if(mobileNo !== undefined){
    if(Number(mobileNo?.length) !== 10) return setShowToolTip(true);
    if((otpCardShow === false)){
      handleOTP();
      SetOtpCardShow(true)
    }else{
      SetOtpCardShow(false)
    }    
  }else{
    setShowToolTip(true);
  } 
  }
  const handelChange = (e) =>{
    SetMobileNo(e)
  }

  const handleCountryCode = e => {
    setSelected(e)
    countryCodes.map(country =>{
      if(country.code === e){
        setUserCountry(country.phone_code)
      }
    })
  }

  function fetchCountryCodes(){
    getCountry().then(response => {
        if(!response.error) {
          setCountryCodes(response.data);
          countryLable(response.data);
        }else {
          alert(`Error : ${response.message}`);
        }
    })
  };

  useEffect( () => {
    fetchCountryCodes()
  }, [])


  const countryLable = (countries) =>{    
    let transLabel = {}
    countries.map( (country,index) => {
      transLabel[country.code] = {
        primary : country.phone_code
    }
          
    })

    setCountryLables(transLabel);
    //Example -  {"GB": {"primary": "+44"}
  }

  const handleOTP = (whatsappFlag = 0) => {
    sendOtp(mobileNo, userCountry, whatsappFlag).then(resp => {
        if(resp.is_user_exists){
          SetOtpCardShow(true)    
        }    
      }).catch(error => {
        console.log(error)
      })
  }
    return(
      (!isUserLogged) ? 
      <ChakraProvider theme={theme}>
        <Flex className="screen-detect-cntr" justifyContent="center" alignItems="center" flexFlow="column"> 
        <Flex className="screen-detect" flexFlow="column">
        {!otpCardShow &&
        <Box>
        <LoginTitleCard 
        CardTitle={"Instant Check Out"} 
        CardInfo={"We need your mobile number so that you can access the purchased photos in future"}/>
        <Flex 
        alignItems="center"
        justifyContent="space-between"
        ml="5"
        mt="10"
        pr="2"> 

        <Flex mt="1">
        <ReactFlagsSelect
          optionsSize={14}
          searchable={true}
          searchPlaceholder="Search countries"
          placeholder="🇮🇳 +91"
          selected={selected}
          countries={countryCodes.map( country => country.code)}
          customLabels={countryLables}
          onSelect={e => handleCountryCode(e)}
          /></Flex>


        <NumberInput
          pl="2"
          pr="2"
          w="100%"
          max={10}
          keepWithinRange={false}
          clampValueOnBlur={false}
          onChange={(e) => handelChange(e)}
          >
          <NumberInputField 
          border="thin solid rgba(77, 77, 77, 0.3) !important"
          fontSize="13px"
          className='ps-desktop-width-auto'
          onClick={() =>setShowToolTip(false)}/>
        </NumberInput>
        {showToolTip && <Tooltip label="Please enter 10 number" placement="top-start" isOpen mt="-40px"> </Tooltip>}
        </Flex>

        <Text
        pl="6"
        fontSize="12px"
        fontWeight="400"
        pt="3"
        color="#999999">
          We’ll send you a 4 digit verification code
        </Text>
        <Text
        pl="6"
        fontSize="12px"
        fontWeight="400"
        pt="6"
        color="#786d6d">
          By continuing, you agree to Memzo’s <Link href="/#" color="#FA2F45">Terms of use</Link> and <Link href="/#" color="#FA2F45">Privacy Policy</Link>
        </Text>
        <Button
        mt="16"
        ml="5"
        color="white"
        bg="#FA2F45"         
        h="12"
        pl="8"
        pr="8"
        fontWeight="700"
        fontSize="15px"
        borderRadius="40"
        onClick={() => OtpCardBtn(true)}>
        Continue
        </Button>
        </Box>
        }
        
        {otpCardShow &&
        <OtpCardCheckout isPurchaseAll={location.state.isPurchaseAll} handleOTP={handleOTP} redirectUrl={redirectBack} countryCode={userCountry} PhoneNo={mobileNo} ShowOtpCard={OtpCardBtn}/>
        }
        </Flex>
        </Flex>
    </ChakraProvider> : null
)}
export default InstantCheckout;
